module.exports = __webpack_public_path__ + "media/images/cooliers-logo-13f919fe.png";